/**
 * ANALİTİK SOYUTLAMASI
 *
 * Uygulama GA4/Meta Pixel'i doğrudan çağırmaz. Tek bir `track()` vardır;
 * hangi sağlayıcının yüklü olduğu burada çözülür.
 *
 * Sağlayıcı yüklenmemişse (reklam engelleyici, ölçüm kimliği tanımsız,
 * geliştirme ortamı) uygulama HİÇBİR şekilde kırılmaz — olay sessizce
 * düşer, yalnızca geliştirme konsoluna yazılır.
 */

type GtagFn = (...args: unknown[]) => void;
type FbqFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    gtag?: GtagFn;
    fbq?: FbqFn;
  }
}

export interface AnalyticsEvents {
  search: { search_term: string };
  view_search_results: { search_term: string; results: number };
  add_to_wishlist: { item_id: string; item_name: string; value?: number };
  remove_from_wishlist: { item_id: string; item_name: string };
  view_item: { item_id: string; item_name: string; value?: number };
  add_to_cart: { item_id: string; item_name: string; value?: number; quantity: number };
  begin_checkout: { value: number; items: number };
  purchase: { transaction_id: string; value: number };
}

/** GA4 olay adı → Meta Pixel karşılığı (varsa). */
const META_EVENT: Partial<Record<keyof AnalyticsEvents, string>> = {
  search: 'Search',
  add_to_wishlist: 'AddToWishlist',
  view_item: 'ViewContent',
  add_to_cart: 'AddToCart',
  begin_checkout: 'InitiateCheckout',
  purchase: 'Purchase',
};

export function track<K extends keyof AnalyticsEvents>(
  event: K,
  params: AnalyticsEvents[K],
): void {
  try {
    window.gtag?.('event', event, params);

    const metaEvent = META_EVENT[event];

    if (metaEvent) {
      window.fbq?.('track', metaEvent, params);
    }

    if (import.meta.env.DEV) {
      // Geliştirmede olayların aktığını görebilmek için.
      console.debug('[analytics]', event, params);
    }
  } catch {
    // Ölçüm hiçbir zaman kullanıcı akışını bozmaz.
  }
}
